export default __webpack_public_path__ + "static/media/create_audiences.770f389e.png";